
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import ChannelsSection from './components/ChannelsSection';
import ServicesSection from './components/ServicesSection';
import DifferentialsSection from './components/DifferentialsSection';
import ProcessSection from './components/ProcessSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Take Lead",
    "description": "Consultoria especializada em prospecção de negócios com IA e automação",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
    "logo": "https://static.readdy.ai/image/54e10434a90951f6daafe5abdc38c83e/206bfcb76a7cb46d5bb10fadf5f7a01d.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+55-11-5043-2111",
      "contactType": "customer service",
      "email": "contato@takelead.com.br",
      "availableLanguage": "Portuguese"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "BR"
    },
    "sameAs": [
      "https://linkedin.com/company/takelead",
      "https://twitter.com/takelead",
      "https://instagram.com/takelead"
    ],
    "offers": {
      "@type": "Service",
      "name": "Prospecção com Inteligência Artificial",
      "description": "Serviços de prospecção automatizada usando IA para aumentar leads qualificados"
    }
  };

  return (
    <div className="min-h-screen bg-black text-white font-['Inter']">
      <SEOHead
        title="Take Lead - Inteligência Artificial para Prospecção de Negócios"
        description="Consultoria especializada em prospecção de negócios com IA e automação. Aumente suas oportunidades qualificadas com tecnologia avançada."
        keywords="inteligência artificial, prospecção, automação, leads, vendas, IA, marketing digital, CRM"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`}
        ogImage={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/og-image.jpg`}
        structuredData={structuredData}
      />
      <Header />
      <main>
        <HeroSection />
        <ChannelsSection />
        <ServicesSection />
        <DifferentialsSection />
        <ProcessSection />
        {/* Contact Section */}
        <ContactSection />
      </main>
      
      <Footer />
    </div>
  );
}
